import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { P } from 'sushiweb/Typography/Text';
import grey from 'sushiweb/tokens/color/grey';
import { logoutUser } from '../../../../actions/auth';
import { openErrorToast } from '../../../../reducers/uiLogic';
import {
  BalanceDetailsWrapper,
  BalanceWidgetHead,
  BalanceWidgetName,
  BalanceWidgetWrapper,
  IncreaseLimitLink,
} from './styles';
import {
  formatAmountInRupees,
  getAvailableWorkspaceLimit,
} from '../../../../helpers';
import { applicableFlowTypes, currentFlowTypeEnum } from '../constants';
import IncreaseBudgetLimitModal from '../IncreaseBudgetLimitModal';

const BalanceWidget = ({ selectedWorkspace, currentFlow }) => {
  const [isIncreaseLimitModalVisible, setIsIncreaseLimitModalVisible] =
    useState(false);
  return (
    <BalanceWidgetWrapper>
      <BalanceWidgetHead>
        <BalanceWidgetName>
          {currentFlow === currentFlowTypeEnum.FLOW_TYPE_LIMIT ? (
            <BalanceDetailsWrapper>
              <P> Available budget: </P>
              {' '}
              <P id='amount'>
                &nbsp;
                {getAvailableWorkspaceLimit(selectedWorkspace)}
              </P>
              <P style={{ color: grey.z400, marginLeft: '0.4rem' }}>
                {'/ '}
                {formatAmountInRupees(selectedWorkspace?.credit_limit)}
              </P>
              <IncreaseLimitLink
                onClick={() => setIsIncreaseLimitModalVisible(true)}
              >
                + Increase
              </IncreaseLimitLink>
              <IncreaseBudgetLimitModal
                isVisible={isIncreaseLimitModalVisible}
                closeModal={() => setIsIncreaseLimitModalVisible(false)}
                creditLimit={selectedWorkspace?.credit_limit ?? 0}
              />
            </BalanceDetailsWrapper>
          ) : (
            <BalanceDetailsWrapper>
              <P> Current balance: </P>
              {' '}
              <P id='amount'>
                &nbsp;
                {formatAmountInRupees(selectedWorkspace?.balance ?? 0)}
              </P>
            </BalanceDetailsWrapper>
          )}
        </BalanceWidgetName>
      </BalanceWidgetHead>
    </BalanceWidgetWrapper>
  );
};

BalanceWidget.propTypes = {
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
};

BalanceWidget.defaultProps = {
  selectedWorkspace: {},
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
};

const mapDispatchToProps = dispatch => ({
  logUserOut: () => dispatch(logoutUser()),
  showErrorToast: () => dispatch(openErrorToast()),
});

export default connect(
  null,
  mapDispatchToProps,
)(BalanceWidget);
